import { createContext } from '@lit/context';
export class NotificationBarContext {
    toggle(...args) {
        this.toggleListener?.(...args);
    }
    close(...args) {
        this.closeListener?.(...args);
    }
    focus(...args) {
        this.focusListener?.(...args);
    }
    blur(...args) {
        this.blurListener?.(...args);
    }
    mouseEnter(...args) {
        this.mouseEnterListener?.(...args);
    }
    mouseLeave(...args) {
        this.mouseLeaveListener?.(...args);
    }
    onToggle(listener) {
        this.toggleListener = listener;
    }
    onClose(listener) {
        this.closeListener = listener;
    }
    onFocus(listener) {
        this.focusListener = listener;
    }
    onBlur(listener) {
        this.blurListener = listener;
    }
    onMouseEnter(listener) {
        this.mouseEnterListener = listener;
    }
    onMouseLeave(listener) {
        this.mouseLeaveListener = listener;
    }
}
export const notificationBarContext = createContext('notification-bar-context');
export const notificationBarCurrentId = createContext('notification-bar-current-id');
//# sourceMappingURL=notification-bar-context.js.map